export default __webpack_public_path__ + "static/media/banner-3.79d357ed.png";